import { AppContent } from '../AppContent';

const mayfairAccountError: AppContent['mayfairAccountError'] = {
  mayfairAccountErrorContent: [
    {
      serviceName: 'Online for Business',
      header: 'About the business',
      errorHeader: 'You’ll need to register a different way',
      errorSummary:
        'As a Mayfair account holder, you’ll need to register as a View Only User.',
      stepsHeader: 'Follow these steps to register:',
      stepOne: 'Fill out the registration form.',
      stepOneHref:
        'https://onlinebusiness.lloydsbank.co.uk/business/a/registration/selectRegistrationType.jsp?WT.ac=IB_Register&LBGAc=T1BUT1VUTVVMVElNRVNTQUdF.MQ==.TEJHYzM=.eXM3dGJtYzAyMDBYNExGbGxveWRzYmFua2NvbQ==.QU1DVlNfMjMwRDY0M0U1QTI1NTA5ODBBNDk1REI2JTQwQWRvYmVPcmc=.MQ==.QU1DVl8yMzBENjQzRTVBMjU1MDk4MEE0OTVEQjYlNDBBZG9iZU9yZw==.LTIxMjExNzkwMzN8TUNJRFRTfDE5ODE5fE1DTUlEfDMzNjY5MzQ0OTYxODM0MDIxMzEwODYzNjc0MDI3MzcyMjE0Nzk2fE1DQUFNTEgtMTcxMjkxNDU1Nnw2fE1DQUFNQi0xNzEyOTE0NTU2fDZHMXluWWNMUHVpUXhZWnJzel9wa3FmTEc5eU1YQnBiMnpYNWR2SmRZUUp6UFhJbWRqMHl8TUNPUFRPVVQtMTcxMjMxNjk1NnN8Tk9ORXxNQ0FJRHxOT05FfHZWZXJzaW9ufDUuMy4w.T1BUT1VUTVVMVEk=.MDowfGMxOjF8YzM6MHxjNTowfGM0OjB8YzI6MA==.dHM=.bHVtaHlzZmQ=',
      stepTwo: 'Print and sign the form.',
      stepThree: 'Post the form back to us.',
      backBtnLabel: 'Back to lloydsbank.com',
      backBtnHref:
        'https://www.lloydsbank.com/business/banking-online/online-for-business/register-for-online-for-business.html',
    },
  ],
};

export default mayfairAccountError;
